import Immutable from 'seamless-immutable';
import BuildConfig from './BuildConfig';

export default Immutable({
  BUILD: BuildConfig.DEV,
});

export const roles = {
  notSet: { id: 0, finnish: 'Ei asetettu', role: 'Not set', permissions: 'None' },
  systemAdmin: {
    id: 1,
    finnish: 'Järjestelmän admin',
    role: 'System administrator',
    permissions: 'Access to every distributor and customers under each distributor',
  },
  ticketingAdmin: {
    id: 2,
    finnish: 'Viihdekäyttäjä admin',
    role: 'Ticketing administrator',
    permissions: 'Access to distributor inside token and customer inside token',
  },
  customerAdmin: {
    id: 3,
    finnish: 'Asiakas admin',
    role: 'Customer administrator',
    permissions: 'Access to distributor inside token and customer inside token',
  },
  distributorAdmin: {
    id: 4,
    finnish: 'Toimittaja admin',
    role: 'Distributor administrator',
    permissions: 'Access to distributor inside token and all customers under that',
  },
  mobileUser: {
    id: 5,
    finnish: 'Mobiilikäyttäjät',
    role: 'Mobile user',
    permissions: 'Access to distributor inside token and customer inside token',
  },
};

export const rolesArray = [
  { id: 5, name: 'mobileUser' },
  { id: 2, name: 'ticketingAdmin' },
  { id: 3, name: 'customerAdmin' },
  { id: 4, name: 'distributorAdmin' },
  { id: 1, name: 'systemAdmin' },
];

export const languages = [
  { id: 0, name: 'Suomi', code: 'fi' },
  { id: 1, name: 'English', code: 'en' },
  { id: 2, name: 'Svenska', code: 'sv' },
  { id: 3, name: 'Deutsch', code: 'de' },
  { id: 4, name: 'Polskie', code: 'pl' },
  { id: 5, name: 'Español', code: 'es' },
];

export const status = [
  { id: 1, name: 'active' },
  { id: -1, name: 'removed' },
  { id: 0, name: 'passive' },
];

export const days = [
  { id: 0, name: 'monday' },
  { id: 1, name: 'tuesday' },
  { id: 2, name: 'wednesday' },
  { id: 3, name: 'thursday' },
  { id: 4, name: 'friday' },
  { id: 5, name: 'saturday' },
  { id: 6, name: 'sunday' },
];

export const datePresets = [
  { id: '1', name: 'today' },
  { id: '2', name: 'last24Hours' },
  { id: '3', name: 'yesterday' },
  { id: '4', name: 'currentWeek' },
  { id: '5', name: 'lastWeek' },
  { id: '6', name: 'currentMonth' },
  { id: '7', name: 'lastMonth' },
];

export const eventReportColumns = [
  // { columnId: 0, name: 'id', translation: 'ReportManager_getEventReport_col1' },
  { columnId: 1, name: 'time', translation: 'ReportManager_getEventReport_col2' },
  { columnId: 2, name: 'controller', translation: 'ReportManager_getEventReport_col3' },
  { columnId: 3, name: 'tag', translation: 'ReportManager_getEventReport_col4' },
  { columnId: 4, name: 'event', translation: 'ReportManager_getEventReport_col5' },
  { columnId: 5, name: 'person', translation: 'ReportManager_getEventReport_col6' },
  { columnId: 6, name: 'controllerUid', translation: 'ReportManager_getEventReport_col7' },
  { columnId: 7, name: 'site', translation: 'ReportManager_getEventReport_col8' },
  { columnId: 8, name: 'controllerReaderDirection', translation: 'ReportManager_getEventReport_col9' },
];

export const controllerReaderDirection = ['IN', 'OUT'];
export const controllerReaderBitCount = ['26', '32', '56'];
export const controllerReaderReadType = ['DEC', 'HEX'];
export const controllerReaderRevert = ['True', 'False'];

export const customerProfiles = {
  normal: 'NORMAL_ENV',
  technopolis: 'TECHNOPOLIS_ENV',
};

export const availableSettings = {
  ajax: 'IS_AJAX_ALLOWED',
  hid: 'IS_HID_IN_USE',
  fakeSetting: 'IS_FAKE_SETTING_ALLOWED',
};

export const EVENT_REPORT_EXCEL_MAX_ROWS = 500;
